import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { Button } from '../ui/button';
import { Image as ImageIcon } from 'lucide-react';

export function QuickPostBox({ user, onCreateClick }) {
  const firstName = user?.display_name?.split(' ')[0] || 'there';

  return (
    <Card className="mb-6">
      <CardContent className="p-4">
        <div className="flex items-center gap-3">
          <Avatar className="w-10 h-10">
            <AvatarImage src={user?.avatar_url} />
            <AvatarFallback>{user?.display_name?.charAt(0)}</AvatarFallback>
          </Avatar>
          <button
            onClick={onCreateClick}
            className="flex-1 text-left px-4 py-2 bg-muted rounded-full text-muted-foreground hover:bg-muted/80 transition-colors"
            data-testid="quick-post-btn"
          >
            What's your pup up to today, {firstName}?
          </button>
          <Button variant="ghost" size="icon" onClick={onCreateClick}>
            <ImageIcon className="w-5 h-5 text-muted-foreground" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}

export default QuickPostBox;
